<template>
	<div :class="[companyClass , canScroll]" v-loading="pageLoading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="page-table column mb-20" :class="{'flex':!isMobile, 'overflow':isMobile}">
			<div class="page-header">
				<h1 class="pageTitle">Compliance checks</h1>
				<h4>settings</h4>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>settings</el-breadcrumb-item>
					<el-breadcrumb-item>compliance</el-breadcrumb-item>
					<el-breadcrumb-item>checks</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<resize-observer @notify="handleResize" />

            <!--<el-row :gutter="10">
                <el-col :span="6">
                    <el-select v-model="portal" placeholder="Select Portal" class="w-100">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            -->
            <el-row :gutter="10" class="mt-10">
                <el-col :span="6">
                    <span>First Name</span><span :class="required"> *</span>
                    <el-input placeholder="FirstName" v-model="firstName" name="firstName" v-validate="'required'" data-vv-as="first Name"></el-input>
                     <transition name="fade">
                            <span class="danger-text">{{ errors.first('firstName') }}</span>
                        </transition>
                </el-col>
                <el-col :span="6">
                    <span>Middle Name</span>
                    <el-input placeholder="MiddleName" v-model="middleName"></el-input>
                </el-col>
                <el-col :span="6">
                    <span>Last Name</span><span :class="required"> *</span>
                    <el-input placeholder="LastName" v-model="lastName" name="lastName" v-validate="'required'" data-vv-as="last Name" ></el-input>
                     <transition name="fade">
                            <span class="danger-text">{{ errors.first('lastName') }}</span>
                        </transition>
                </el-col>
                <el-col :span="6">
                    <br>
                    <el-button type="primary" icon="el-icon-search" @click="validateAndSave" > Search</el-button>
                </el-col>
            </el-row>

            <el-row :gutter="10" class="mt-10">
                <el-col :span="20">
                    <h2><strong>Status: </strong>{{totalFound}}</h2>
                </el-col>
                <el-col :span="20">
                    <h2><strong>Message: </strong>{{found}}</h2>
                </el-col>
            </el-row>



            <!--<el-collapse accordion class="mt-20">
                <el-collapse-item name="1">
                    <template slot="title">
                        <span style="color:green;" class="pl-10"><b> SOURCES CHECKED  ({{sources_used.length}})</b></span>
                    </template>
                    <el-table class="pl-10"
                    :data="sources_used"
                    style="width: 100%">
                    <el-table-column
                        prop="source"
                        label="Source Name">
                    </el-table-column>
                    </el-table>
                </el-collapse-item>
                <el-collapse-item name="2">
                    <template slot="title">
                        <span style="color:red;" class="pl-10"><b> FOUND ({{totalFound}})</b></span>
                    </template>
                    <el-collapse accordion class="pl-10"  style="color:red;">
                        <el-collapse-item v-for="p in found" :key="p.id" :title="p.name" :name="p.id">
                            <div>Alt Names: {{p.alt_names ? p.alt_names.toString() : ''}}</div>
                            <div>Dates of Birth: {{p.dates_of_birth ? p.dates_of_birth.toString() : ''}}</div>
                            <div>Source: {{p.source}}</div>
                        </el-collapse-item>
                    </el-collapse>
                </el-collapse-item>
            </el-collapse>-->
		</div>
	</div>
</template>

<script>
import moment from 'moment-timezone'
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';
import { Validator } from 'vee-validate'
import { bus } from '@/main'

export default {
    name: 'Compliance',
    data() {
        return {
            options: [{
                label: 'OFAC',
                value: 'https://api.trade.gov/consolidated_screening_list/search?api_key=AScCgxkC5DbV13QcfTvMoUWA'
            },
            {
                value: 'PEPS',
                url: 'Option2'
            }],
            portal: '1',
            firstName: '',
            middleName: '',
            lastName: '',
            sources_used: [],
            found: [],
            totalFound: [],
            //totalFound: 0
        }
    },
	methods: {
        validateAndSave() {
			this.$validator.validateAll()
			.then((result) => {
            this.check();
          	})
			.catch((err) => {
            console.log(err);
          });
		},
        check() {
            this.startLoader("Getting Compliance Details...");
            this.complianceCheck(this.portal, this.firstName, this.middleName, this.lastName)
            .then(result=> {
                if(result){
                    this.sources_used = 'AML';
                    this.found = result.message;
                    this.totalFound = result.status;
                }
                this.stopLoader();
          	}).catch(err=> { this.errorMessage("An Error Occured. " +err); this.stopLoader();});
        }
	},
	mixins: [PermissionsMixins]
}
</script>
